<template>
  <div id="edit-project">
    <form novalidate >
             <v-dialog
        v-model="create_coupon_v"
        width="500"
      >
        <v-card>
          <v-card-title
            class="headline grey lighten-2"
            primary-title>
            {{'coupons._Create_Coupons_'|translate}}
          </v-card-title>
          <v-card-text>
          {{'coupons._add_coupon_'|translate}}
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
           <v-btn class="md-primary" @click="create_coupon_v = false">{{'general._close_'|translate}}</v-btn>
            <v-btn class="md-primary" @click="newCoupon">{{'coupons._create_coupon_'|translate}}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
       
             <v-dialog
      v-model="loading"
      hide-overlay
      persistent
      width="300"
    >
      <v-card
        color="primary"
        dark
      >
        <v-card-text>
         {{'general._wait_'|translate}}
          <v-progress-linear
           indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
      <v-container grid-list-xl fluid>
        <v-layout row wrap>
          <v-snackbar v-model="infoUpdatedSnack">
            <span>{{'merchants._merchants_saved_succ_'|translate}}</span>
            <v-btn class="md-primary" @click="infoUpdatedSnack = false">{{'general._ok_'|translate}}</v-btn>
          </v-snackbar>
          <!-- project form -->
          <v-toolbar :md-elevation="1">
            <span class="md-title">{{'merchants._merchants_buis_name_'|translate}} : <b>{{form.business_name}}</b></span>
            <span class="md-title"> {{'merchants._merchants_date_'|translate}} : <b>{{ form.createdDate }}</b></span>
          </v-toolbar>
          <br>

          <v-flex sm6 style="display:none">
            <v-text-field
              label="Titre du buisness"
              type="text"
              autocomplete="given-name"
              v-model="merchant_id"
              required
            ></v-text-field>
          </v-flex>


          <v-flex xs12 sm6>
            <v-text-field
            :label="$t('merchants._merchants_buis_name_')"
            
              v-model="form.business_name"
              autocomplete="given-name"
              required
            ></v-text-field>
          </v-flex>
    
          <v-flex xs12>
            <h5>{{'merchants._merchants_descr_'|translate}}</h5>

            <v-textarea
              placeholder="Détailler"
              ref="projectDescription"
              v-model="form.business_description"
              :min-height="30"
              :max-height="350"
              
              outline
            ></v-textarea>
          </v-flex>

     <v-flex xs12 sm6>

    <!--      <v-select
              :items="discount"
              v-model="form.discount"
              :label="$t('merchants._merchants_discount_')"
              item-text="name"
              item-value="value"
              single-line
            ></v-select> -->
 
            <v-text-field
              label="phone"
              v-model="form.phone"
              autocomplete="given-name"
              required
            ></v-text-field>
          </v-flex>

   <!--      <v-flex xs12 sm6>
            <v-widget title="Opeing Time" class="mt-3">
              <div slot="widget-content">
                <v-dialog
                  ref="dialog"
                  persistent
                  v-model="modal"
                  lazy
                  full-width
                  width="290px"
                  :return-value.sync="date"
                >
                  <v-text-field
                    slot="activator"
                    label="Opeing Time"
                    v-model="form.operating_hours_open"
                    prepend-icon="event"
                    readonly
                  ></v-text-field>
                  <v-date-picker v-model="form.operating_hours_open" scrollable>
                    <v-spacer></v-spacer>
                    <v-btn flat color="primary" @click="modal = false">{{'general._cancel_'|translate}}</v-btn>
                    <v-btn flat color="primary" @click="$refs.dialog.save(date)">{{'general._ok_'|translate}}</v-btn>
                  </v-date-picker>
                </v-dialog>
              </div>
            </v-widget>
          </v-flex> -->


          <v-flex xs12 sm6>
     <div class="container" id="app">
  <div class="added-days">


     <ul class="list-unstyled">
    <li class="clearfix" v-for="day in form.addedDays">
     <!--  {{addedDays}} -->
      {{ day.dayName }} from
      {{ day.openingTimeName }} to 
      {{ day.closingTimeName }}
      <v-btn color="primary" @click.prevent="removeDay(day)">Remove</v-btn>
    </li>
  </ul>
    
  </div>
  
  <div class="form">
    <select v-model="selectedDay" class="select-drop">
      <option v-for="day in days" v-bind:value="day.value">
        {{ day.name }}
      </option>
    </select>

    <select v-model="selectedOpeningTime" class="select-drop">
      <option v-for="openingTime in filteredOpeningTimes" v-bind:value="openingTime.value">
        {{ openingTime.name }}
      </option>
    </select>

    <select v-model="selectedClosingTime" class="select-drop">
      <option v-for="closingTime in filteredClosingTimes" v-bind:value="closingTime.value">
        {{ closingTime.name }}
      </option>
    </select>

    <v-btn couleur="primary" @click="addDay">Add Hours</v-btn>
  </div>
  
</div>

      </v-flex>
      
        <!--    <v-flex xs12 sm6>
            <v-widget title="Closing Time" class="mt-3">
              <div slot="widget-content">
                <v-dialog
                  ref="dialog"
                  persistent
                  v-model="modal"
                  lazy
                  full-width
                  width="290px"
                  :return-value.sync="date"
                >
                  <v-text-field
                    slot="activator"
                    label="Closing Time"
                    v-model="form.operating_hours_close"
                    prepend-icon="event"
                    readonly
                  ></v-text-field>
                  <v-date-picker v-model="form.operating_hours_close" scrollable>
                    <v-spacer></v-spacer>
                    <v-btn flat color="primary" @click="modal = false">{{'general._cancel_'|translate}}</v-btn>
                    <v-btn flat color="primary" @click="$refs.dialog.save(date)">{{'general._ok_'|translate}}</v-btn>
                  </v-date-picker>
                </v-dialog>
              </div>
            </v-widget>
          </v-flex> -->
    
     
          <v-flex xs12 sm6>
            <v-text-field
              :label="$t('coupons._cop_city_')"
              type="text"
              autocomplete="name"
              
              v-model="form.city"
            ></v-text-field>
          </v-flex>
            <v-flex xs12 sm6>
            <v-text-field
             :label="$t('coupons._cop_region_')"
              type="text"
              autocomplete="name"
              
              v-model="form.Region"
            ></v-text-field>
          </v-flex>
            <v-flex xs12 sm6>
            <v-text-field
              :label="$t('coupons._cop_civic_')"
              type="text"
              autocomplete="name"
              v-model="form.civic"
            ></v-text-field>
          </v-flex>

           
          <v-flex xs12 sm6>
            <v-text-field
              :label="$t('coupons._cop_postalCode_')"
              type="text"
              autocomplete="name"
              v-model="form.postal_code"
            ></v-text-field>
          </v-flex>

                <v-flex xs12 class="text-xs-center text-sm-center text-md-center text-lg-center">
          
        	<img :src="imageUrl" height="150" v-if="imageUrl"/>
          
					<v-text-field label="Select Image" @click='pickFile_image' v-model='imageName' prepend-icon='attach_file'></v-text-field>
					<input
						type="file"
						style="display: none"
						ref="image"
						accept="image/*"
						@change="onFilePicked_image"
           
					>

				</v-flex>
       
       <v-flex xs12>
            <v-layout row wrap>
              <v-card-actions style="display:inline">
                <v-btn @click="deleteMerchant" color="primary">{{'general._delete_'|translate}}</v-btn>
              </v-card-actions>

              <v-card-actions style="display:inline">
                <router-link :to="{ name: 'widget-merchants'}">
                  <v-btn color="primary">{{'general._back_'|translate}}</v-btn>
                </router-link>
              </v-card-actions>

              <v-spacer></v-spacer>
              <v-card-actions style="display:inline">
                <v-btn type="submit" color="primary" @click="updateMerchants" >{{'general._save_'|translate}}</v-btn>
              </v-card-actions>
            </v-layout>
          </v-flex>
         
        </v-layout>
      </v-container>
    </form>
  </div>
</template>

<script>
/* eslint-disable */
import { db } from "@/api/firebaseInit";
import firebase from "firebase";
import { storage } from '@/api/firebaseInit';
import vueSlider from "vue-slider-component";
import { quartiers } from "@/api/quartiers";
import { communes } from "@/api/communes";
import Vue from 'vue';
const toLower = text => {
  return text.toString().toLowerCase();
};



const searchByName = (items, term) => {
  if (term) {
    return items.filter(item => toLower(item.title).includes(toLower(term)));
  }

  return items;
};

export default {
  name: "edit-merchant",
  components: {
    vueSlider
  },
    props: ['list'],
    computed: {
    merchants(){
      let merchants =  this.$store.getters.merchants;
      return merchants;
    },
    filteredOpeningTimes: function() {
      return this.openingTimes.filter(function (el) {
        return el.value < this.selectedClosingTime;
      }, this);
    },
    
    filteredClosingTimes: function() {
      return this.closingTimes.filter(function (el) {
        return el.value > this.selectedOpeningTime;
      }, this);
    },
    
    selectedDayName: function() {
      return this.days[this.selectedDay].name;
    },
    
    selectedOpeningTimeName: function() {
      return this.openingTimes[this.selectedOpeningTime].name;
    },
    
    selectedClosingTimeName: function() {
      return this.closingTimes[this.selectedClosingTime].name;
    } 
  },
  mounted() {  
 // this.projects =  this.$store.getters.projects;
   //  console.log(" projects "+JSON.stringify(this.projects))     
  },
  created() {
    this.merchant_id = this.$route.params.merchant_id;
    this.created_by_id = firebase.auth().currentUser.uid;
    this.created_by = firebase.auth().currentUser.displayName;
  },
  filters: {
    formatDate: function(value) {
      if (value) {
        return moment(String(value)).format("MM/DD/YYYY");
      }
    }
  },
  data() {
    return {

    addedDays: [],
    selectedDay: 0,
    selectedOpeningTime: 8,
    selectedClosingTime: 17,
        discount: [
      { value: 10, name: '10 %' },
      { value: 20, name: '20 %' },
      { value: 30, name: '30 %' },
      { value: 40, name: '40 %' },
      { value: 50, name: '50 %' },
      { value: 60, name: '60 %' },
      { value: 70, name: '70 %' },
      { value: 80, name: '80 %' },
      { value: 90, name: '90 %' },
      { value: 100, name: '100 %' },
    ],
    days: [
      { value: 0, name: 'Monday' },
      { value: 1, name: 'Tuesday' },
      { value: 2, name: 'Wednesday' },
      { value: 3, name: 'Thursday' },
      { value: 4, name: 'Friday' },
      { value: 5, name: 'Saturday' },
      { value: 6, name: 'Sunday' },
    ],
    openingTimes: [
      { value: 0, name: '12 am (midnight)' },
      { value: 1, name: '1:00 am' },
      { value: 2, name: '2:00 am' },
      { value: 3, name: '3:00 am' },
      { value: 4, name: '4:00 am' },
      { value: 5, name: '5:00 am' },
      { value: 6, name: '6:00 am' },
      { value: 7, name: '7:00 am' },
      { value: 8, name: '8:00 am' },
      { value: 9, name: '9:00 am' },
      { value: 10, name: '10:00 am' },
      { value: 11, name: '11:00 am' },
      { value: 12, name: '12:00 pm (noon)' },
      { value: 13, name: '1:00 pm' },
      { value: 14, name: '2:00 pm' },
      { value: 15, name: '3:00 pm' },
      { value: 16, name: '4:00 pm' },
      { value: 17, name: '5:00 pm' },
      { value: 18, name: '6:00 pm' },
      { value: 19, name: '7:00 pm' },
      { value: 20, name: '8:00 pm' },
      { value: 21, name: '9:00 pm' },
      { value: 22, name: '10:00 pm' },
      { value: 23, name: '11:00 pm' },
      { value: 24, name: '12:00 am (midnight next day)' },
      { value: 25, name: '1:00 am (next day)' },
      { value: 26, name: '2:00 am (next day)' },
      { value: 27, name: '3:00 am (next day)' },
      { value: 28, name: '4:00 am (next day)' },
      { value: 29, name: '5:00 am (next day)' },
      { value: 30, name: '6:00 am (next day)' },
    ],
    closingTimes: [
      { value: 0, name: '12 am (midnight)' },
      { value: 1, name: '1:00 am' },
      { value: 2, name: '2:00 am' },
      { value: 3, name: '3:00 am' },
      { value: 4, name: '4:00 am' },
      { value: 5, name: '5:00 am' },
      { value: 6, name: '6:00 am' },
      { value: 7, name: '7:00 am' },
      { value: 8, name: '8:00 am' },
      { value: 9, name: '9:00 am' },
      { value: 10, name: '10:00 am' },
      { value: 11, name: '11:00 am' },
      { value: 12, name: '12:00 pm (noon)' },
      { value: 13, name: '1:00 pm' },
      { value: 14, name: '2:00 pm' },
      { value: 15, name: '3:00 pm' },
      { value: 16, name: '4:00 pm' },
      { value: 17, name: '5:00 pm' },
      { value: 18, name: '6:00 pm' },
      { value: 19, name: '7:00 pm' },
      { value: 20, name: '8:00 pm' },
      { value: 21, name: '9:00 pm' },
      { value: 22, name: '10:00 pm' },
      { value: 23, name: '11:00 pm' },
      { value: 24, name: '12:00 am (midnight next day)' },
      { value: 25, name: '1:00 am (next day)' },
      { value: 26, name: '2:00 am (next day)' },
      { value: 27, name: '3:00 am (next day)' },
      { value: 28, name: '4:00 am (next day)' },
      { value: 29, name: '5:00 am (next day)' },
      { value: 30, name: '6:00 am (next day)' },
    ],

      //projects:[],
      create_coupon_v:false,
      loading: false,
      Download_image_url:"",
      imageName : '',
			imageFile : '',
			imageUrl : '',
      old_images:[],
      members: [],
      pagination: {
        sortBy: "title",
        rowsPerPage: "100"
      },
      job_type: ["Part-Time", "Full-Time"],
      date: null,
      menu: false,
      modal: false,
      infoUpdatedSnack: false,
      jobs: [],
      backers: [],
      zones: quartiers,
      areas: communes,
      merchant_id: null,
      coupon_id:null,
      form: {
          created_by: firebase.auth().currentUser.displayName,
          owner_id:firebase.auth().currentUser.uid, 
          merchant_id:'',
          business_description:'',
          business_name:'',
          coupon_ids:[],
          createdDate:'', 
          discount:'',
          imageUrl:'', 
          MerchantPoint:{},
          operating_hours_close:'',
          operating_hours_open:'',
          city:'',
          civic:'',
          Region:'',
          addedDays:[],
          postal_code:'',
          phone:""
      }
    };
  },
  beforeRouteEnter(to, from, next) {
    var created_date = new Date()
    db.collection("Merchants")
      .doc(to.params.merchant_id)
      .get()
      .then(function(doc) {
        created_date = new Date(doc.data().created_date.seconds*1000)
         // exp_date = exp_date.getFullYear() + "-" + ("0" + (exp_date.getMonth() + 1)).slice(-2) + "-" +("0" + exp_date.getDate()).slice(-2)
        next(vm => {

        
                 (vm.form.owner_id= doc.data().owner_id),
                 (vm.form.created_by= doc.data().created_by),
                 (vm.form.postal_code=doc.data().address.postal_code),    
                 (vm.form.city=doc.data().address.city),
                 (vm.form.civic=doc.data().address.civic),
                 (vm.form.Region=doc.data().address.Region),
                 (vm.form.addedDays=doc.data().operating_hours),
                 (vm.form.operating_hours_close=doc.data().operating_hours.close),
                 (vm.form.operating_hours_open=doc.data().operating_hours.open),
                 (vm.form.available_position= doc.data().available_position),
                 (vm.form.business_description= doc.data().business_description), 
                 (vm.form.business_name= doc.data().business_name), 
                 (vm.form.hourly_wages= doc.data().hourly_wages),
                 (vm.form.createdDate= created_date),
                 (vm.form.phone=  doc.data().phone)
                
         

        });
      });
  },
  watch: {
    $route: "fetchData"
  },
  methods: {

    remove(array, element) {
  return array.filter(el => el !== element);
},

    addDay: function() {
      this.form.addedDays.push({
       
        id: this.selectedDay, 
        openingTime: this.selectedOpeningTime, 
        closingTime: this.selectedClosingTime,
        dayName: this.selectedDayName,
        openingTimeName: this.selectedOpeningTimeName,
        closingTimeName: this.selectedClosingTimeName,
        open:true,
      });
    },

     removeDay: function(day) {
      console.log('removed ' + day.dayName);
        for(var i=0 ; i<this.form.addedDays.length; i++)
{
    if(this.form.addedDays[i].dayName==day.dayName)
        this.form.addedDays.splice(i);
}



    },
      newCoupon() {
      const that = this;
      const memberRef = db.collection("available_coupons").doc();
      const refKey = memberRef.id;
      this.coupon_id = refKey;
      memberRef
        .set({
                id:this.coupon_id,
                barcode_url: "",
                image_url:"",
                created_by_id:this.created_by_id,
                created_date:new Date(),
                description:"", 
                discount:0,
                expiration_date:new Date(), 
                merchant_id:this.merchant_id,
                store_name:"",
                phone:"",
                address:{town:'',region:'',postal_code:'',civic:''}
        })
        .then(() => {
           this.$store.dispatch('fetchMerchants')
           this.$router.push({
            name: "components/modifiers-editcoupon",
            params: {
              coupon_id: that.coupon_id
            }
          });
        })
        .catch(error => {
          console.error("Error adding member: ", error);
        });
    },
  pickFile_image (type) {
            this.$refs.image.click ()
        },
    searchOnTable() {
      this.searched = searchByName(this.jobs, this.search);
    },
    getClass: ({ type }) => ({
      // 'md-primary':
    }),
    onSelect(item) {
      this.selected = item;
      this.$router.push({
        name: "edit-merchant",
        params: {
          merchant_id: item.merchant_id
        }
      });
    },
    fetchData() {
      var created_date = new Date()
      db.collection("Merchants")
        .doc(this.merchant_id)
        .get()
        .then(function(doc) {
          created_date = new Date(doc.data().created_date.seconds*1000)
                 (this.form.owner_id= doc.data().owner_id),
                 (this.form.createdBy= doc.data().createdBy),
                  (this.form.postal_code=doc.data().address.postal_code),   
                 (this.form.city=doc.data().address.city),
                 (this.form.civic=doc.data().address.civic),
                 (this.form.Region=doc.data().address.Region),
                 (this.form.addedDays=doc.data().operating_hours),
                 (this.form.operating_hours_close=doc.data().operating_hours.close),
                 (this.form.operating_hours_open=doc.data().operating_hours.open),   
                 (this.form.available_position= doc.data().available_position),
                 (this.form.business_description= doc.data().business_description), 
                 (this.form.business_name= doc.data().business_name), 
                 (this.form.hourly_wages= doc.data().hourly_wages),
                 (this.form.created_date= created_date), 
                 (this.form.phone= doc.data().phone);

                      
        });
    },

    updateMerchants() {
      var that = this;
      var address ={}
      var bloc ={}
      var operating_hours =[]

     // operating_hours.open = this.form.operating_hours_open;
     // operating_hours.close = this.form.operating_hours_close;
      //   operating_hours = this.addedDays
      address.city= this.form.city
      address.civic= this.form.civic
      address.Region= this.form.Region
     
       var latLng ={}   
       Vue.$geocoder.setDefaultMode('address');
           
          var addressObj = {
          address_line_1: this.form.civic,
          address_line_2: '',
          city:           this.form.city,
          state:          this.form.Region,               // province also valid
          zip_code:       this.form.postal_code,            // postal_code also valid
            }

        Vue.$geocoder.send(addressObj, response => { 
        latLng={lat:response.results[0].geometry.location.lat,long:response.results[0].geometry.location.lng}
  
        //console.log(JSON.stringify(latLng)) 
      db.collection("Merchants")
        .doc(this.merchant_id)
        .update({
          MerchantPoint:latLng,
          address: address,
          business_description:this.form.business_description,
          business_name:this.form.business_name,
          created_date:new Date(), 
          phone:this.form.phone,
          imageUrl:this.Download_image_url, 
          operating_hours: this.form.addedDays  
             
        })
        .then(() => {
          that.infoUpdatedSnack = true;
          that.create_coupon_v=true;
             this.$store.dispatch('fetchJobs')
        })
        .catch(error => {
          console.error("Error adding member: ", error);
        });
      });
    },

    backtoRoute () {
       return '/widget-post';
    },
    deleteMerchant() {
      var that = this;
      if (confirm("Are you sure?")) {
        db.collection("Merchants")
          .doc(this.merchant_id)
          .delete()
          .then(function() {
            alert(`Cette Merchant a été suprimé`);
           
          });
           this.$store.dispatch('fetchMerchants')
            this.$router.push({name: 'widget-merchants'});
      }
    },
       saveImageUrl (url) {
           this.loading = false;
           this.Download_image_url=url;
            console.log("url",this.Download_image_url)
        
        },

    onFilePicked_image (e) {
        var blob="";
       var that = this
      const files = e.target.files
     
			if(files[0] !== undefined) {
           this.loading = true;
				this.imageName = files[0].name
				if(this.imageName.lastIndexOf('.') <= 0) {
					return
				}
				const fr = new FileReader ()
				fr.readAsDataURL(files[0])
				fr.addEventListener('load', () => {
					this.imageUrl = fr.result
					this.imageFile = files[0] // this is an image file that can be sent to server...
        })
        
          blob = new Blob([files[0]], { type: files[0].type });
          //console.log("blob",blob)
       
     // Upload file and metadata to the object 'images/mountains.jpg'
var uploadTask = storage.ref().child(`media_attachements/${this.created_by_id}/medias/file-${new Date().getTime()}`).put(blob);
var prograss =0;
// Listen for state changes, errors, and completion of the upload.
uploadTask.on(firebase.storage.TaskEvent.STATE_CHANGED, // or 'state_changed'
  function(snapshot) {
  
    // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
    var progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
   
  //  console.log('Upload is ' + progress +'val'+ '% done');
    switch (snapshot.state) {
      case firebase.storage.TaskState.PAUSED: // or 'paused'
       // console.log('Upload is paused');
        break;
      case firebase.storage.TaskState.RUNNING: // or 'running'
      //  console.log('Upload is running');
         this.valueDeterminate=progress
        break;
    }
  }, function(error) {

  // A full list of error codes is available at
  // https://firebase.google.com/docs/storage/web/handle-errors
  switch (error.code) {
    case 'storage/unauthorized':
      // User doesn't have permission to access the object
      break;

    case 'storage/canceled':
      // User canceled the upload
      break;

    case 'storage/unknown':
      // Unknown error occurred, inspect error.serverResponse
      break;
  }
}, function() {

  // Upload completed successfully, now we can get the download URL
  uploadTask.snapshot.ref.getDownloadURL().then(function(downloadURL) {
    console.log('File available at', downloadURL);
     that.saveImageUrl(downloadURL)
          
             downloadURL=''
             blob=''
             
  });
});

  

			} else {
				this.imageName = ''
				this.imageFile = ''
				this.imageUrl = ''
			}
		}
  }

};
</script>
<style lang='scss' scoped>
.md-dialog {
  max-width: 768px;
}
body {
  padding-top: 70px;
}
.md-drawer {
  padding-top: 70px;
}

#my-strictly-unique-vue-upload-multiple-image {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}

h1,
h2 {
  font-weight: normal;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #42b983;
}

.form {
  background-color: #f0f8ff;
  margin-bottom: 40px;
  padding: 40px;
}

.added-days li {
  background-color: #eee;
  margin-bottom: 10px;
  padding: 8px;
}

.select-drop {
  margin: 10px;
  width: 100px;
  padding: 5px 35px 5px 5px;
  font-size: 16px;
  border: 1px solid #ccc;
  height: 34px;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  background-color:  #ccc;
}

</style>



// WEBPACK FOOTER //
// src/pages/modifiers/EditMerchant.vue